import React from 'react';
import '../estilos/Recepcion.css';

const RutaCriticaRecepcion = ({
  certificados = [],
  fechasRecepcion = {},
  projectName = ''
}) => {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  // Aplanar todos los documentos de todas las partidas, calcular días restantes por fechaEsperada
  const documentosCriticos = certificados
    .flatMap(cert => (cert.documentos || []).map(doc => ({
      ...doc,
      partida: cert.nombrePartida || '',
      especialidad: cert.especialidad || '',
    })))
    .filter(doc => !doc.completado && doc.fechaEsperada)
    .map(doc => {
      const fecha = new Date(doc.fechaEsperada + 'T12:00:00');
      fecha.setHours(0, 0, 0, 0);
      const diffMs = fecha - hoy;
      const diasRestantes = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      return { ...doc, diasRestantes };
    })
    .sort((a, b) => a.diasRestantes - b.diasRestantes)
    .slice(0, 20);

  const getEstado = (dias) => {
    if (dias <= 0) return { label: 'VENCIDO', bg: '#1a1a1a', color: '#fff' };
    if (dias <= 3) return { label: 'CRÍTICO', bg: '#fef2f2', color: '#dc2626' };
    if (dias <= 7) return { label: 'URGENTE', bg: '#fff7ed', color: '#ea580c' };
    if (dias <= 14) return { label: 'MEDIO', bg: '#fefce8', color: '#ca8a04' };
    return { label: 'A TIEMPO', bg: '#f0fdf4', color: '#16a34a' };
  };

  const getDiasStyle = (dias) => {
    if (dias <= 0) return { color: '#dc2626', bg: '#fee2e2' };
    if (dias <= 3) return { color: '#dc2626', bg: '#fef2f2' };
    if (dias <= 7) return { color: '#ea580c', bg: '#fff7ed' };
    if (dias <= 14) return { color: '#ca8a04', bg: '#fefce8' };
    return { color: '#16a34a', bg: '#f0fdf4' };
  };

  const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const formatearFecha = (fechaStr) => {
    if (!fechaStr) return '-';
    const partes = fechaStr.split('-');
    if (partes.length !== 3) return fechaStr;
    const mes = meses[parseInt(partes[1], 10) - 1] || partes[1];
    return `${partes[2]}/${mes}/${partes[0]}`;
  };

  return (
    <div className="tab-content">
      <section className="critical-section">
        <div className="critical-header-bar">
          <span className="recepcion-badge">RECEPCION</span>
          <span className="critical-date">{new Date().toLocaleDateString('es-CL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
        </div>
        <div className="critical-title-row">
          <span className="critical-square" style={{ color: '#111827' }}>■</span>
          <span className="critical-title-text">Ruta Crítica — Documentos Recepción Final</span>
          <span className="critical-count-badge" style={{ background: '#f3f4f6', color: '#111827' }}>{documentosCriticos.length}</span>
        </div>

        {fechasRecepcion.fechaRecepcionEsperada ? (
          <div style={{ display: 'flex', gap: '10px', marginBottom: '14px', flexWrap: 'wrap' }}>
            {fechasRecepcion.fechaRecepcionEsperada && (
              <div style={{
                display: 'flex', flexDirection: 'column', gap: '2px',
                background: 'white', borderRadius: '8px', padding: '8px 16px',
                border: '1px solid #e5e7eb', borderLeft: '3px solid #111827',
                boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
              }}>
                <span style={{ fontSize: '9px', fontWeight: 700, color: '#4b5563', textTransform: 'uppercase', letterSpacing: '0.8px' }}>
                  Termino Programado
                </span>
                <span style={{ fontSize: '14px', fontWeight: 700, color: '#111827' }}>
                  {formatearFecha(fechasRecepcion.fechaRecepcionEsperada)}
                </span>
              </div>
            )}
          </div>
        ) : null}

        {documentosCriticos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
            <p style={{ fontSize: '16px', fontWeight: 600 }}>No hay documentos pendientes con fecha esperada</p>
            <p style={{ fontSize: '13px' }}>Los documentos completados no aparecen en la ruta crítica</p>
          </div>
        ) : (
          <div className="table-wrapper">
            <table className="critical-table-email">
              <thead>
                <tr>
                  <th style={{ textAlign: 'center', width: '40px' }}>#</th>
                  <th>Especialidad</th>
                  <th>Partida</th>
                  <th>Documento</th>
                  <th style={{ textAlign: 'center' }}>F. Programado</th>
                  <th style={{ textAlign: 'center' }}>Días</th>
                  <th style={{ textAlign: 'center' }}>Estado</th>
                </tr>
              </thead>
              <tbody>
                {documentosCriticos.map((doc, index) => {
                  const estado = getEstado(doc.diasRestantes);
                  const diasStyle = getDiasStyle(doc.diasRestantes);
                  return (
                    <tr key={`${doc.id}-${index}`} className={index % 2 === 0 ? 'row-even' : 'row-odd'}>
                      <td style={{ textAlign: 'center', color: '#999' }}>{index + 1}</td>
                      <td>{doc.especialidad || '-'}</td>
                      <td>{doc.partida || '-'}</td>
                      <td className="cell-name">{doc.nombre || '-'}</td>
                      <td style={{ textAlign: 'center' }}>{formatearFecha(doc.fechaEsperada)}</td>
                      <td style={{ textAlign: 'center' }}>
                        <span className="status-badge" style={{ background: diasStyle.bg, color: diasStyle.color, fontWeight: 700 }}>
                          {doc.diasRestantes <= 0 ? doc.diasRestantes : `${doc.diasRestantes}`}d
                        </span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <span className="status-badge" style={{ background: estado.bg, color: estado.color }}>
                          {estado.label}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </section>

    </div>
  );
};

export default RutaCriticaRecepcion;
